<template>
  <div class="flex">
    <div>
      <!-- {{ this.$getters }} -->
      <!-- {{ selectedCompany }} -->
      <div class="combo_box">
        <v-select
          class="company"
          v-model="selectedCompany"
          :items="items"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          item-value="id"
          label="경영체"
          dense outlined
        ></v-select>
      </div>

      <div class="Space_container mt-2">
        <div class="tree-container">
          <div 
            v-for="company in TreeData.filter(comp => comp.company_cd === selectedCompany)" 
            :key="company.company_cd" 
            class="tree-node company company-node mt-2"
          >
            <div class="flex vertical-center">
              <div class="company-label tree-label flex s-bt" @click="onCompanyClick(company)">
                <div>
                  <v-icon color="white" size="24" class="mr-1">mdi-chevron-double-down</v-icon>
                  {{ company.company_name }}
                </div>   
              </div>
            </div>

            <div 
              v-for="farm in TreeData.find(comp => comp.company_cd === selectedCompany)?.farms || []" 
              :key="farm.farm_cd" 
              class="tree-node farm-node"
            >
    
            <div class="flex vertical-center">
              <div class="farm-label tree-label flex s-bt" @click="onFarmClick(farm)">
                <div>
                  <v-icon color="#2C5177" size="26" class="mr-1">mdi-domain</v-icon>
                  {{ farm.farm_name }}
                </div>   
              </div>

              <div @click="FarmClick()">
                <v-icon color="#2C5177">mdi-playlist-plus</v-icon>
              </div>
            </div>

              <div class="tree-children">
                <div 
                  v-for="building in farm.buildings" 
                  :key="building.building_cd" 
                  class="tree-node building-node mt-2"
                >
                  <div class="tree-label flex">
                    <v-icon @click.stop="toggleRoom(building)" color="#005B96">
                      {{ building.isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                    </v-icon>
                    <div @click="onBuildingClick(building)">
                      {{ building.building_name }}
                    </div>
                    <div class="ml-2 info_count">
                    {{ building.rooms.length }}
                    </div>
                  </div>
                  <div class="tree-children" v-if="building.isOpen">
                    <div 
                      v-for="room in building.rooms" 
                      :key="room.room_cd" 
                      class="tree-node room-node"
                      @click="onRoomClick(room)"
                    >
                      {{ room.room_name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="register_container">
      <div class="tab-container flex">
        <div class="tab-content">
          <button class="tab mr-1" 
            :class="{ active: selectedTab === 'company' }" 
            @click="selectTab('company')">
            {{ tabLabel.company }}
          </button>
          <button class="tab mr-1" 
            :class="{ active: selectedTab === 'farm' }" 
            @click="selectTab('farm')">
            {{ tabLabel.farm }}
          </button>
          <button class="tab mr-1"
            :class="{ active: selectedTab === 'building' }" 
            @click="selectTab('building')">
            {{ tabLabel.building }}
          </button>
          <button class="tab"
            :class="{ active: selectedTab === 'room' }" 
            @click="selectTab('room')">
            {{ tabLabel.room }}
          </button>
        </div>
      </div>

      <div class="info-content">
        <component
          :is="currentComponent"
          :selected-item="selectedItem"
          :selected-company="selectedCompany"
          :ref="selectedTab"
          @refreshTreeData="fetchTreeViewData"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Apis from "@/api/apis";
import dateUtil from "@/utils/custom/dateProperty.js";
import VueCookies from "vue-cookies";

// 컴포넌트 임포트
import companyForm from "./company.vue";
import farmForm from "./farm.vue";
import buildingForm from "./building.vue";
import roomForm from "./room.vue";

export default {
  name: "RegisterSpace",
  components: {
    companyForm,
    farmForm,
    buildingForm,
    roomForm,
  },
  data() {
    return {
      items: [], 
      TreeData: [],

      selectedCompany: null,
      selectedTab: "company", 
      selectedItem: null,
    };
  },
  computed: {
    currentComponent() {
      switch (this.selectedTab) {
        case "company":
          return "companyForm";
        case "farm":
          return "farmForm";
        case "building":
          return "buildingForm";
        case "room":
          return "roomForm";
        default:
          return null;
      }
    },
    tabLabel() {
      const farm_biz = this.selectedItem?.farm?.farm_biz || "";
      switch (farm_biz) {
        case "CF02":
          return { company:"경영체", farm: "농장", building: "축사", room: "돈방" };
        case "CF04":
          return { company:"경영체", farm: "농장", building: "축사", room: "계사" };
        case "CF05":
          return { company:"경영체", farm: "농장", building: "축사", room: "우사" };
        case "CF06":
          return { company:"경영체", farm: "농장", building: "축사", room: "우사" };
        default:
          return { company:"경영체", farm: "사업장", building: "건물", room: "위치" };
      }
    }
  },
  watch:{
    selectedCompany(newValue) {
      if (newValue) {
        VueCookies.set("selectedCompany", newValue, "30d"); 
      }
      const company = this.TreeData.find(comp => comp.company_cd === newValue);
      if (company) {
        this.$nextTick(() => {
          this.onCompanyClick(company);
        });
      }
    },
  },
  created() {
    this.fetchTreeViewData();
  },
  methods: {
    fetchTreeViewData() {
      Apis.treeManagermentCompanies({ 
          account: this.$getters.userInfo.account, 
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd" 
        )},(res) => {
          // console.log(res.data)
          const filterCompany = res.data.filter((company) => 
            company.farms && company.company_cd !== ''
          );

          this.TreeData = filterCompany.map((company) => ({
            ...company,
            farms: company.farms.map((farm) => ({
              ...farm,
              buildings: farm.buildings.map((building) => ({
                ...building,
                isOpen: false,
              })),
              isOpen: false
            })),
          }));

          this.items = filterCompany.map((company) => ({
            id: company.company_cd,
            name: company.company_name,
          }));
          
          if (!this.selectedCompany && filterCompany.length > 0) {
            this.selectedCompany = filterCompany[0].company_cd;

            // 첫 번째 경영체 정보를 자동으로 표시
            this.$nextTick(() => {
              this.onCompanyClick(filterCompany[0]);
            });
          }
      });
    },
    getTreeViewData(value) {
      const company = this.TreeData.find((comp) => comp.company_cd === value);
      return company ? company.farms : [];
      
    },
    toggleRoom(building) {
      building.isOpen = !building.isOpen;
    },
    selectTab(tab) {
      this.selectedTab = tab;
      // console.log(tab)
      // this.selectedItem = null;
      if (tab === "room" && !this.selectedItem) {
        this.selectedItem = {
          farm: {}, 
          building: {},
          room: {},
        };
      }else{
        this.selectedItem = null;
      }
    },
    FarmClick(){
      this.selectedTab = "farm";
    },
    onCompanyClick(company) {
      this.selectedTab = "company";
      //  console.log(company)
      this.selectedItem = company ? { company_cd: company.company_cd } : null;

      this.$nextTick(() => {
        const companyRef = this.$refs[this.selectedTab];

        if (companyRef?.infoDetail) {
          companyRef.infoDetail({
            company_cd: company.company_cd,
          });
        } else {
          console.warn("infoDetail 메서드를 찾을 수 없습니다.");
        }
      })
    },
    onFarmClick(farm) {
      this.selectedTab = "farm";
      
      // console.log(farm)
      this.selectedItem = {
        company_cd: this.selectedCompany,
        farm: {
          farm_cd: farm.farm_cd,
          farm_name: farm.farm_name,
          farm_biz : farm.farm_biz
        },
      };
      
      //경영체 업데이트
      const company = this.TreeData.find((comp) =>
        comp.farms.some((f) => f.farm_cd === farm.farm_cd)
      );
      if (company) {
        this.selectedCompany = company.company_cd;
      }
      
      this.$nextTick(() => {
        const farmRef = this.$refs[this.selectedTab];
        if (farmRef?.infoDetail) {
          farmRef.infoDetail({
            farm_cd: farm.farm_cd,
            farm_name: farm.farm_name,
            // farm_biz : farm.farm_biz
          });
        } else {
          console.warn("infoDetail 메서드를 찾을 수 없습니다.");
        }
      })
    },
    onBuildingClick(building) {
      this.selectedTab = "building";

      const farm = this.TreeData.find((comp) => comp.company_cd === this.selectedCompany)
        ?.farms.find((f) => f.buildings.some((b) => b.building_cd === building.building_cd));

      this.selectedItem = {
        company_cd: this.selectedCompany,
        company_name: this.items.find(item => item.id === this.selectedCompany)?.name, 
        
        farm: {
          farm_cd: farm.farm_cd,
          farm_name: farm.farm_name,
          farm_biz : farm.farm_biz
        },
        building: {
          building_cd: building.building_cd,
          building_name: building.building_name,
        },
      };

      this.$nextTick(() => {
        const buldingRef = this.$refs[this.selectedTab];
        if (buldingRef?.infoDetail) {
          buldingRef.infoDetail({
            building_cd: building.building_cd,
            building_name: building.building_name,
          });
        } else {
          console.warn("infoDetail 메서드를 찾을 수 없습니다.");
        }
      })
    },
    onRoomClick(room) {
      // console.log(room)
      this.selectedTab = "room";

      const company = this.TreeData.find((comp) => comp.company_cd === this.selectedCompany);
      const farm = company?.farms.find((f) => f.buildings.some((b) => b.rooms.some((r) => r.room_cd === room.room_cd)));
      const building = farm?.buildings.find((b) => b.rooms.some((r) => r.room_cd === room.room_cd));

      // console.log(farm)
      this.selectedItem = {
        company:{
          company_cd: this.selectedCompany,
          company_name: this.items.find(item => item.id === this.selectedCompany)?.name, 
        },
        farm: {
          farm_cd: farm.farm_cd,
          farm_name: farm.farm_name,
          farm_biz : farm.farm_biz
        },
        building: {
          building_cd: building.building_cd,
          building_name: building.building_name,
        },
        room: {
          room_cd: room.room_cd,
          room_name: room.room_name,
        },
      }
      this.$nextTick(() => {
        const roomRef = this.$refs[this.selectedTab];
        if (roomRef?.infoDetail) {
          roomRef.infoDetail({
            room_cd: room.room_cd,
            room_name: room.room_name,
          });
        } else {
          console.warn("infoDetail 메서드를 찾을 수 없습니다.");
        }
      })
    }
  },
};
</script>



<style lang="scss" scoped>
@import "../info_style/info_style.scss";
.combo_box{
  width:270px;
  display:flex;
  margin-top:5px;
}

.Space_container {
  max-width: 350px;
  width: 35vw;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding:5px 18px 18px 5px ;
  border-radius: 20px;
  background-color:white;
}
.company{
  margin-left:5px !important;
  margin-top:10px !important;
}
::v-deep .company .v-input__slot{
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); /* 그림자 효과 */
  background-color: white !important;
  border:none !important;
}

// 트리뷰
.company{
  border: 1px solid #d2d2d2;
  border-radius: 10px;
  padding:10px;
  margin-top:10px;
  // min-width:315px;
}
.tree-node {
  margin-left: 15px;
}
.company-label{
  background-color: $main-color;
  color:white;
  border-radius: 30px !important;
}

.tree-label {
  cursor: pointer;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.tree-label:hover {
  background-color: #d6d6d6;
  color:$main-color;
}

.farm-label{
  background-color : #9EC7F3;
  color:#2C5177!important;
  border-radius: 30px;
  font-size:17px;
  margin-left:5px;
}
.farm-node .tree-label {
  color: black;
}
.farm-node{
  margin-top:5px;
  margin-left:0;
}

.building-node .tree-label {
  color: $main-color;
  font-size:17px;
  letter-spacing: -1px;
  background-color: $menu-color;
}

.room-node {
  margin-left:30px !important;
  margin-top:10px;
  font-weight:500;
  letter-spacing: -0.75px;
  cursor: pointer;
}
.room-node:hover{
  background-color: $menu-color;
  padding:10px;
  color:$main-color;
  font-weight:550;
  border-radius: 10px;
}

.register_conatiner{
  margin-left:15px;
}
.info-content{
  margin-left:10px;
  margin-top:10px;
  background-color: white;
  border-radius: 20px;
  border: 1px solid #E9E9E9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding:20px;
}

.tab-container{
  // justify-content:end;
  align-items: center;
}
.tab-content {
  display: inline-flex;
  padding:5px;
  background-color: #F3F3F3;
  border-radius: 5px;
  overflow: hidden; /* 버튼이 탭 영역을 넘지 않도록 */
  height: 50px;
}

.tab {
  flex: 1;
  width: 80px;
  font-size:16px !important;
  font-weight:600 !important;

  border-radius: 20px;
  border: none;
  background-color: #e7e7e7;
  color: #bababa; 
  cursor: pointer;
  transition: all 0.5s ease;
}

.tab.active {
  background-color: $point-color; 
  color: white;
  font-weight:600;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2); 
}

.tab:not(.active):hover {
  background-color: #f0f0f0; 
}
.info_count{
  background: $main-color;
  color: white;
  border-radius: 10px;
  width:30px;
  height:20px;
  margin-top:3px;
  font-size:13px;
  // line-height:25px;
  // font-weight:450;
  text-align: center;
  // padding:0px 10px;
}
</style>
